module.exports = __webpack_public_path__ + "static/img/modular-frame_64.0072284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modular-frame_64.png
// module id = lSvc
// module chunks = 0